import React, { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { Share } from "lucide-react";
import { toast } from "sonner";

export interface TableAction {
  key: string;
  render: () => React.ReactNode;
  onClick: () => void;
}

export const useTableActions = () => {
  const { t } = useTranslation();

  const handleShare = useCallback(() => {
    navigator.clipboard.writeText(window.location.href);
    toast.success(t("gamesAndLiveEvents.table.actions.shareSuccess.title"), {
      description: t(
        "gamesAndLiveEvents.table.actions.shareSuccess.description",
      ),
    });
  }, [t]);

  const getCommonActions = useCallback(
    (): TableAction[] => [
      /*
      {
        key: "export-csv",
        render: () => (
          <>
            <FileDown
              className="mr-2 h-4 w-4"
              aria-label={t("gamesAndLiveEvents.table.actions.exportCsv")}
            />
            {t("gamesAndLiveEvents.table.actions.exportCsv")}
          </>
        ),
        onClick: () => {
          console.log("Implement CSV export");
        },
      },
      */
      {
        key: "share",
        render: () => (
          <>
            <Share
              className="mr-2 h-4 w-4"
              aria-label={t("gamesAndLiveEvents.table.actions.share")}
            />
            {t("gamesAndLiveEvents.table.actions.share")}
          </>
        ),
        onClick: handleShare,
      },
    ],
    [t, handleShare],
  );

  const getScheduledActions = useCallback(
    (): TableAction[] => [
      /* Disable for now
      {
        key: "export-csv",
        render: () => (
          <>
            <FileDown
              className="mr-2 h-4 w-4"
              aria-label={t("gamesAndLiveEvents.table.actions.exportCsv")}
            />
            {t("gamesAndLiveEvents.table.actions.exportCsv")}
          </>
        ),
        onClick: () => {
          console.log("Implement CSV export");
        },
      },
      */
      {
        key: "share",
        render: () => (
          <>
            <Share
              className="mr-2 h-4 w-4"
              aria-label={t("gamesAndLiveEvents.table.actions.share")}
            />
            {t("gamesAndLiveEvents.table.actions.share")}
          </>
        ),
        onClick: handleShare,
      },
    ],
    [t, handleShare],
  );

  const getCompletedActions = useCallback(
    (): TableAction[] => [
      /* Disable for now
      {
        key: "export-csv",
        render: () => (
          <>
            <FileDown
              className="mr-2 h-4 w-4"
              aria-label={t("gamesAndLiveEvents.table.actions.exportCsv")}
            />
            {t("gamesAndLiveEvents.table.actions.exportCsv")}
          </>
        ),
        onClick: () => {
          console.log("Implement CSV export");
        },
      },
      */
      {
        key: "share",
        render: () => (
          <>
            <Share
              className="mr-2 h-4 w-4"
              aria-label={t("gamesAndLiveEvents.table.actions.share")}
            />
            {t("gamesAndLiveEvents.table.actions.share")}
          </>
        ),
        onClick: handleShare,
      },
    ],
    [t, handleShare],
  );

  return {
    getCommonActions,
    getScheduledActions,
    getCompletedActions,
  };
};
